import React from 'react';
import { cn } from '@/lib/utils';

// Shadcn-style Card primitives (named exports)
const ShadcnCard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('rounded-xl border border-white/8 bg-card/40 backdrop-blur-md text-card-foreground shadow-sm', className)}
    {...props}
  />
));
ShadcnCard.displayName = 'Card';

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('flex flex-col space-y-1.5 p-3 sm:p-5', className)} {...props} />
));
CardHeader.displayName = 'CardHeader';

const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3 ref={ref} className={cn('text-lg font-semibold leading-none tracking-tight', className)} {...props} />
));
CardTitle.displayName = 'CardTitle';

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p ref={ref} className={cn('text-sm text-muted-foreground', className)} {...props} />
));
CardDescription.displayName = 'CardDescription';

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('p-3 sm:p-5 pt-0', className)} {...props} />
));
CardContent.displayName = 'CardContent';

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('flex items-center p-3 sm:p-5 pt-0', className)} {...props} />
));
CardFooter.displayName = 'CardFooter';

// Legacy bridge wrapper (default export) preserving old API
function Card({ title, subtitle, children, className = '', action, onClick, scrollable, ...props }) {
  return (
    <div
      className={cn(
        'rounded-xl border border-white/8 bg-card/40 backdrop-blur-md text-card-foreground shadow-sm',
        scrollable && 'flex flex-col overflow-hidden',
        className,
      )}
      onClick={onClick}
      {...props}
    >
      {(title || action) && (
        <div className="px-3 sm:px-5 py-3 border-b border-white/8 flex items-center justify-between shrink-0">
          <div>
            {title && <h2 className="text-lg font-bold text-foreground">{title}</h2>}
            {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
          </div>
          {action && <div>{action}</div>}
        </div>
      )}
      <div className={cn('p-3 sm:p-5', scrollable && 'overflow-y-auto overflow-x-hidden flex-1 min-h-0')}>{children}</div>
    </div>
  );
}

export default Card;
export {
  ShadcnCard,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
};
